import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output, signal, WritableSignal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HashtagComponent } from '@app/components/addons/hashtags/hashtag/hashtag.component';
import { Subject, takeUntil } from 'rxjs';
import { SvgComponent } from '../../svg/svg.component';
import { SettingsService } from '@app/_services/settings.service';
import { ModalService } from '@app/_services/modal.service';

@Component({
    selector: 'app-filter-hashtag',
    imports: [
        CommonModule,
        SvgComponent
    ],
    templateUrl: './filter-hashtag.component.html',
    styleUrl: './filter-hashtag.component.scss'
})
export class FilterHashtagComponent {

  unSubscribe = new Subject<void>();
  @Input() signal: WritableSignal<string[]> = signal<string[]>([]);
  @Output() select = new EventEmitter<string[]>();

  constructor(public dialog: MatDialog, public ss: SettingsService, private cdr: ChangeDetectorRef, private modalService: ModalService) {

  }

  getLabel() {
    if (this.signal().length === 0) {
      return this.ss.t('common_hashtag');
    } else if (this.signal().length === 1) {
      return this.ss.tagMap()[this.signal()[0]];
    } else {
      return this.ss.t('common_filterHashtagMultiple', { numberOfHashtag: this.signal().length.toString() });
    }
  }

  openHashtagsDialog() {
    const dialog = this.modalService.openLevel2(HashtagComponent, {
      values: this.signal(),
      type: 'filter'
    }, {
      disableClose: true
    })

    this.modalService.getClosedObservable(dialog).pipe(takeUntil(this.unSubscribe)).subscribe(result => {
      if (result) {
        this.signal.set(result);
        this.select.emit(result);
      }
      this.cdr.markForCheck();
    });
  }
}
